import { AccountPermissionsResponse } from '../api/account/accountApiTypes';
import { UserAuthenticatedPayload } from '../action/authenticationEvents';

/**
 * Maps the DB-driven `GET /admin/account/permissions` response into the
 * `userAuthenticated` payload the auth reducer expects (#1377).
 *
 * The single DB `role` becomes the one-element `roles` array the legacy role
 * selectors check — mirroring the former `SELF_SERVICE_OWNER_ROLES = ['owner']`
 * so master/receptionist/manager role checks stay false for self-service users
 * exactly as before. The permission strings come straight from the backend,
 * which is now the single source of truth.
 */
export const toAuthPayload = (
    perms: AccountPermissionsResponse,
): UserAuthenticatedPayload => ({
    permissions: perms.permissions,
    roles: [perms.role],
});
